// ── Compras Tab ───────────────────────────────────────────────────────────────
import { getTrip }        from '@/store/tripState';
import { saveTrip }       from '@/services/sync.service';
import { toArr, sanitize } from '@/helpers';
import type { CompraItem, CompraCat } from '@/types';

export function renderCompras(): void {
  const el     = document.getElementById('compras-list');
  const cntEl  = document.getElementById('compras-count');
  const search = ((document.getElementById('compras-search') as HTMLInputElement)?.value ?? '').toLowerCase();
  if (!el) return;

  let arr = toArr(getTrip().compras ?? {}) as CompraItem[];
  if (search) arr = arr.filter(c =>
    (c.descricao ?? '').toLowerCase().includes(search) ||
    (c.marca ?? '').toLowerCase().includes(search));

  const done    = arr.filter(c => c.done).length;
  const pending = arr.filter(c => !c.done);
  const finished= arr.filter(c => c.done);
  if (cntEl) cntEl.textContent = arr.length ? `${done}/${arr.length} comprados` : '';

  if (!arr.length) { el.innerHTML = '<div class="empty">Nenhum item na lista.</div>'; return; }

  const sortKey = (c: CompraItem) => `${c.cat ?? 'Outros'}|||${c.loja ?? ''}|||${c.descricao ?? ''}`.toLowerCase();
  pending.sort((a, b) => sortKey(a).localeCompare(sortKey(b), 'pt-BR'));
  finished.sort((a, b) => sortKey(a).localeCompare(sortKey(b), 'pt-BR'));

  const renderGroup = (items: CompraItem[]): string => {
    const byCat: Partial<Record<string, Record<string, CompraItem[]>>> = {};
    items.forEach(c => {
      const cat  = (c.cat ?? 'Outros') as CompraCat;
      const loja = c.loja || 'Sem loja';
      if (!byCat[cat]) byCat[cat] = {};
      if (!byCat[cat]![loja]) byCat[cat]![loja] = [];
      byCat[cat]![loja].push(c);
    });
    return Object.keys(byCat).sort((a, b) => a.localeCompare(b, 'pt-BR')).map(cat => {
      const lojas = byCat[cat as CompraCat]!;
      const catDone = Object.values(lojas).flat().filter(c => c.done).length;
      const catTotal= Object.values(lojas).flat().length;
      return `
        <div class="compras-cat">
          <div class="compras-cat-header"><span>${cat}</span><span style="font-size:11px">${catDone}/${catTotal}</span></div>
          ${Object.keys(lojas).sort((a, b) => a.localeCompare(b, 'pt-BR')).map(loja => `
            <div class="compras-loja-group">
              ${loja !== 'Sem loja' ? `<div class="compras-loja-header">🏪 ${sanitize(loja)}</div>` : ''}
              ${lojas[loja].map(c => `
                <div class="compra-item">
                  <input type="checkbox" ${c.done ? 'checked' : ''} onchange="window.__toggleCompra('${c.id}')">
                  <div class="compra-body">
                    <div class="compra-title ${c.done ? 'done' : ''}" onclick="window.__toggleCompra('${c.id}')">${sanitize(c.descricao ?? '—')}</div>
                    <div class="compra-meta">${[c.marca ? sanitize(c.marca) : '', c.notas ? sanitize(c.notas) : ''].filter(Boolean).join(' · ')}</div>
                  </div>
                  <div class="compra-qty">${c.qty ?? '1'}×</div>
                  <div class="card-actions">
                    <button class="icon-btn" onclick="window.__openModal('compra','${c.id}')">✏</button>
                    <button class="icon-btn del" onclick="window.__delItem('compras','${c.id}')">×</button>
                  </div>
                </div>`).join('')}
            </div>`).join('')}
        </div>`;
    }).join('');
  };

  el.innerHTML = renderGroup(pending) +
    (finished.length ? `
      <div style="font-size:12px;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;padding:12px 0 6px;border-top:0.5px solid var(--border);margin-top:8px">
        ✓ Já comprados (${finished.length})
      </div>${renderGroup(finished)}` : '');
}

export function toggleCompra(id: string): void {
  const c = getTrip().compras?.[id];
  if (c) saveTrip(`compras/${id}/done`, !c.done).catch(() => void 0);
}
